import { has_ssr } from "@core/helpers/render-type";
import { is_media_pathname } from "@core/helpers/url-path";
import {
  get_domain_client,
  get_env_domain_client,
  get_full_url_client,
  get_origin_client,
  get_pathname_client,
  get_protocol_client,
  is_localhost_client,
} from "@core/helpers/client/url";
import {
  get_env_domain_server,
} from "@core/helpers/server/url";

export const get_domain = async () => {
  if (has_ssr()) {
    const { get_domain_server } = require("@core/helpers/server/url");
    return await get_domain_server();
  } else {
    return get_domain_client();
  }
};

export const get_env_domain = () => {
  if (has_ssr()) {
    return get_env_domain_server();
  } else {
    return get_env_domain_client();
  }
};

export const is_localhost = async () => {
  if (has_ssr()) {
    const { is_localhost_server } = require("@core/helpers/server/url");
    return await is_localhost_server();
  } else {
    return is_localhost_client();
  }
};

export const get_protocol = async () => {
  if (has_ssr()) {
    const { get_protocol_server } = require("@core/helpers/server/url");
    return await get_protocol_server();
  } else {
    return get_protocol_client();
  }
};

export const get_full_url = async () => {
  if (has_ssr()) {
    const { get_full_url_server } = require("@core/helpers/server/url");
    return await get_full_url_server();
  } else {
    return get_full_url_client();
  }
};

export const get_pathname = async () => {
  if (has_ssr()) {
    const { get_pathname_server } = require("@core/helpers/server/url");
    return await get_pathname_server();
  } else {
    return get_pathname_client();
  }
};

export const get_slug = async () => {
  const pathname = await get_pathname();
  const pathname_array = pathname?.split("/");
  const filtered_pathname = pathname_array?.filter(
    (item) => (item || "")?.length > 0
  );
  const last_index = filtered_pathname?.length - 1;
  return filtered_pathname[last_index];
};

export const get_origin = async () => {
  if (has_ssr()) {
    const { get_origin_server } = require("@core/helpers/server/url");
    return await get_origin_server();
  } else {
    return get_origin_client();
  }
};

// a slug with a dot (`nike-air-3.5`) is a page, not a file: see `is_media_pathname`
export const is_media_url = async () => {
  return is_media_pathname(await get_pathname());
};

export const generateIdFromName = (text = "") => {
  return text
    .trim()
    .replace(/\u200c/g, " ") // نیم فاصله → فاصله
    .replace(/[؟?.,!،؛:()"'[\]{}]/g, "") // حذف علائم
    .replace(/\s+/g, "-") // فاصله → -
    .toLowerCase();
};
